<template>
    <div class="fordable banner_setting">
        <ul>
            <li>
                <div class="file_wrap">
                    <label for="area_file">
                        <input id="area_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                        <div class="file_box_wrap">
                            {{ banner.file && banner.file.name ? banner.file.name : "PC 이미지를 추가해주세요." }}
                        </div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">PC 이미지 사이즈 2000*777</p>
                    </label>
                    <label for="area_file_mobile">
                        <input id="area_file_mobile" type="file" placeholder="" accept="image/*" multiple @change="handleFilesForMobile" />
                        <div class="file_box_wrap">
                            {{ banner.fileMobile && banner.fileMobile.name ? banner.fileMobile.name : "모바일 이미지를 추가해주세요." }}
                        </div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">모바일 이미지 사이즈 500*466</p>
                    </label>
                </div>
                <div class="link_wrap">
                    <input type="text" placeholder="링크를 입력해주세요" v-model="banner.link" />
                    <button class="border_btn" @click="addBanner">추가</button>
                </div>
            </li>
            <li v-for="(item, idx) in state.bannerList" :key="item.idx">
                <div class="_flex">
                    <button type="button" class="move_up _sub" @click="changeOrder(item, 0)">
                        <img src="img/up_icon.png" alt="" />
                    </button>
                    <button type="button" class="move_down _sub" @click="changeOrder(item, 1)">
                        <img src="img/down_icon.png" alt="" />
                    </button>
                </div>
                <span class="idx_span">{{ item.idx }}</span>
                <div class="tb_img" @click="viewImage(item.file)" v-if="item.file">
                    <img style="max-width: 100%" :src="item.file" alt="" />
                </div>
                <div class="tb_img" @click="viewImage(item.fileMobile)" v-if="item.fileMobile">
                    <img style="max-width: 100%" :src="item.fileMobile" alt="" />
                </div>
                <input type="text" placeholder="입력된 링크가 없습니다." v-model="item.link" disabled />
                <button type="button" class="border_btn" @click="bannerModal(item.idx)">수정</button>
                <button type="button" class="table_btn _gray" @click="isDelete(item.idx)">삭제</button>
            </li>
        </ul>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <BannerModal
        v-if="state.isShowBannerModal"
        :bannerInfo="state.bannerInfo"
        @close="state.isShowBannerModal = false"
        @save="saveBanner"
    ></BannerModal>
</template>

<script lang="ts" config>
    import { reactive, apiService, onMounted, ModalDefault, types, getMessageByCode, BannerModal, CommonUtils } from "@/BaseComponent";

    export default {
        props: {},
        components: {
            ModalDefault,

            BannerModal,
        },
        setup() {
            const state = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                bannerList: [] as any,

                isShowBannerModal: false as boolean,
                bannerInfo: {},
                idxForRemove: 0 as number,
            });

            const banner = reactive({
                file: null as any,
                fileMobile: null as any,
                link: "" as string,
            });

            const isShow = reactive({
                isShowReport: false as boolean,
                isShowBanner: false as boolean,
                isShowGamsi: false as boolean,
                isShowActive: false as boolean,
                isShowBannerPopup: false as boolean,
                isShowFooter: false as boolean,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
            });

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove();
                }
            };

            const viewImage = async (param: string) => {
                state.modalTab = 11;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            const getList = async () => {
                const res: types.ResBannerList = await apiService.banner.list();
                if (res.returnCode === 0) {
                    state.bannerList = res.data;
                }
            };

            const bannerModal = async (idx: number) => {
                if (idx != null && idx > 0 && idx != undefined) {
                    const res = await apiService.banner.detail(idx);

                    if (res.returnCode === 0) {
                        state.bannerInfo = res.data;
                        state.isShowBannerModal = true;
                    }
                }
            };

            const addBanner = async () => {
                if (!banner.file || !banner.fileMobile) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "PC, 모바일 이미지를 모두 등록해주세요.";
                    state.isShowModal = true;
                    return;
                }
                const param: types.ReqBanner = {
                    file: banner.file,
                    fileMobile: banner.fileMobile,
                    link: banner.link,
                };
                const res: types.BaseResponse = await apiService.banner.add(param);
                if (res.returnCode === 0) {
                    state.isShowBannerModal = false;

                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "등록이 완료되었습니다.";
                    state.isShowModal = true;

                    banner.file = null;
                    banner.fileMobile = null;
                    banner.link = "";

                    getList();
                } else {
                    console.error(res.description);
                }
            };

            const saveBanner = async (param: types.ReqBannerForModify) => {
                const res: types.BaseResponse = await apiService.banner.modify(param);
                if (res.returnCode === 0) {
                    state.isShowBannerModal = false;

                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "수정이 완료되었습니다.";
                    state.isShowModal = true;

                    getList();
                } else {
                    console.error(res.description);
                }
            };

            const isDelete = async (idx: number) => {
                state.idxForRemove = idx;

                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
            };

            const remove = async () => {
                const res = await apiService.banner.remove(state.idxForRemove);

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;
                    state.idxForRemove = 0;
                    getList();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const changeOrder = async (banner: types.ResBannerVOForApi, arrow: number) => {
                const param: types.ReqBannerForOrder = {
                    idx: banner.idx,
                    order: arrow,
                };
                const res = await apiService.banner.isOrder(param);
                if (res.returnCode === 0) {
                    getList();
                }
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];

                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }

                banner.file = file;
                target.value = "";
            };

            const handleFilesForMobile = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];

                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }

                banner.fileMobile = file;
                target.value = "";
            };

            return {
                state,
                banner,
                closeModal,
                callBackModal,
                changeOrder,
                bannerModal,
                isDelete,
                viewImage,
                saveBanner,
                handleFiles,
                handleFilesForMobile,
                addBanner,
                CommonUtils,
            };
        },
    };
</script>
<style scoped>
    .file_wrap {
        display: flex;
        gap: 10px;
        align-items: flex-start;
    }

    .fordable.banner_setting .link_wrap {
        flex: 1;
    }
</style>
